import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

import { redirect } from "../../utility/navigate";

class AllureDockerDeleteFolderDialog extends Component {
  deleteFolder = (folderId) => {
    // Без redirectRoot: удаление папки не влияет на открытый проект.
    this.props
      .deleteFolder(folderId)
      .catch((error) => {
        redirect(error);
        this.props.setAPIAlert("error", `Something wrong => ${error.message}`, true);
      });
    this.props.closeDialog();
  };

  render() {
    const folderId = this.props.folderId || "";

    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.closeDialog}
        aria-labelledby="delete-folder-dialog-title"
      >
        <DialogTitle id="delete-folder-dialog-title">Delete Folder {folderId}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            The folder <code>{folderId}</code> is empty and contains no reports. Delete it?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.props.closeDialog} variant="text">
            Cancel
          </Button>
          <Button onClick={() => this.deleteFolder(folderId)} variant="contained" style={{ backgroundColor: "#e6212d", color: "#fff" }}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
export default AllureDockerDeleteFolderDialog;
